<template>
    <PageContainer :breadcrumbs="breadcrumbs">
      <Guides />
    </PageContainer>
</template>

<script lang="ts">
  import { useSeoMeta, definePageMeta, useHead, useRuntimeConfig } from '#imports'
  import { defineNuxtComponent } from '#app'
  import Guides from '@/components/Guides'
  import PageContainer from '@/containers/Page'
  
  export default defineNuxtComponent({
    components: {
      Guides,
      PageContainer,
    },
    async setup() {
      const { public: { APP_ENV } } = useRuntimeConfig()
      const title = '販売ご利用ガイド - カーナベル'
      const description = "カーナベルでの購入方法、支払方法、送料、発送・到着日、キャンセル、返品・交換についてお知らせします"
      useSeoMeta({
        title,
        description,
        ogTitle: title,
        ogDescription: description,
        robots: APP_ENV==='production' ? 'index,follow' :'noindex,nofollow',
        twitterSite: '@ka_nabell_pcg',
        ogSiteName: 'ポケカ販売ならカーナベル！',
        ogUrl: 'https://sell.ka-nabell.com/guides'
      })

      useHead({
        link: [
          {
            rel: 'canonical',
            href: 'https://sell.ka-nabell.com/guides'
          }
        ]
      })
  
      definePageMeta({
        layout: 'default'
      })

      const breadcrumbs = [
        {
          title: 'トレカ販売トップ',
          link: '/',
        },
        {
          title: '販売ご利用ガイド',
        },
      ]

      return {
        breadcrumbs,
      }
    }
  })
</script>
